import { Box, TextField } from '@mui/material'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { observer } from 'mobx-react-lite'
import { Dayjs } from 'dayjs'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'

export type TeamLearningFilterProps = {
  fromDate: Dayjs | null
  toDate: Dayjs | null
  setFromDate: (date: Dayjs | null) => void
  setToDate: (date: Dayjs | null) => void
}

export const TeamLearningFilter = observer(({ fromDate, toDate, setFromDate, setToDate }: TeamLearningFilterProps) => {
  const { translation } = useLocalizationStore()
  const pageTranslation = translation.pages.editPositions

  const handleDateChange = (setter: (date: Dayjs | null) => void) => (newValue: Dayjs | null) => {
    setter(newValue)
  }

  return (
    <Box sx={styles.root}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          label={pageTranslation.startField()}
          inputFormat="YYYY-MM-DD"
          value={fromDate}
          onChange={handleDateChange(setFromDate)}
          renderInput={params => <TextField sx={styles.formText} {...params} />}
        />
        <DesktopDatePicker
          label={pageTranslation.endField()}
          inputFormat="YYYY-MM-DD"
          value={toDate}
          onChange={handleDateChange(setToDate)}
          renderInput={params => <TextField sx={styles.formText} {...params} />}
        />
      </LocalizationProvider>
    </Box>
  )
})

const styles = {
  root: {
    width: '100%',
    display: 'flex',
    gap: 10,
  },
  formText: {
    width: '100%',
    '& .MuiInputBase-root': {
      fontSize: 12,
      height: 37,
      backgroundColor: 'background.paper',
    },
    '& .MuiInputLabel-root': {
      fontSize: 12,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 20,
      color: 'text.secondary',
    },
  },
}